<!--nav1-->
<app-main-nav-bar></app-main-nav-bar>
<div class="main" data-request="1995">
  <div class="wrap">
    <div class="sub-request elem" style="display: block;">
      <div class="row">
        <div class="col col-12">
          <div class="head">
            <h2 style="text-align: center">بیمه گذارها</h2>
            <p>افرادی که تحت پوشش بیمه درمان سلامت می&zwnj;باشند</p>
          </div>
        </div>
      </div>
      <div class="row" *ngFor="let subRequestInfo of requestDetails.getSubRequestsDetails(); let last = last">
        <div class="col col-12">
          <app-details-div
            [rawCount]="3"
            [array]="subRequestInfo.getDisplayArray()"
            [header]="'بیمه گذار' + settings.translateEnglish(subRequestInfo.getGender() + '_TITLE', translation)"
            [id]="subRequestInfo.getSubRequestID()"
            (takeAction)="takeAction($event)"
            [translation]="translation"
            (secondaryClicked)="secondaryClicked(subRequestInfo)"
            [mainLabel]="subRequestInfo.getMaiLabel()"
            [backLabel]="subRequestInfo.getSecondaryLabel()"
          ></app-details-div>
        </div>
      </div>
      <div class="row">
        <div class="col col-12">
          <app-custom-button [BackButton]="true"
                             [HideMainButton]="true"
                             [disabled]="false"
                             [backUrl]="'/HEALTH/requests'"
                             [Show]="myRequestsButton"
                             [backButtonLabel]="'بیمه های من'">
          </app-custom-button>
        </div>
      </div>
    </div>
  </div>
</div>

<div id="offerButtonDiv" style="display: none">
  <app-custom-button
    [LabelText]="'انتخاب طرح'"
    [mode]="'BOTTOM'"
    [Show]="true"
    (OnClick)="selectOffer()">
  </app-custom-button>
</div>
<div id="paymentButtonDiv" style="display: none">
  <app-custom-button
    [LabelText]="'پرداخت حق بیمه'"
    [mode]="'BOTTOM'"
    [Show]="true"
    (OnClick)="showPaymentPanel()">
  </app-custom-button>
</div>
<div id="downloadButtonDiv" style="display: none">
  <app-custom-button
    [LabelText]="'دانلود بیمه نامه'"
    [mode]="'BOTTOM'"
    [Show]="true"
    (OnClick)="download()">
  </app-custom-button>
</div>
<div *ngIf="paymentMode">
  <app-finance-invoice-div
    (OnClickOutSide)="hideFinance()"
    [show]="paymentMode"
    [RequestID]="requestDetails.getRequestID()"
    [productName]="'HEALTH'"
  ></app-finance-invoice-div>
</div>
<app-file-upload-div
  [productName]="'HEALTH'"
  [fileInfo]="fileInfo"
  (ClickOutSide)="hideUpload($event)"
  (refresh)="getDetails(requestDetails.getRequestID())">
</app-file-upload-div>
